var map = {
	"./amazon.png": 85483,
	"./amex.png": 94837,
	"./cirrus.png": 28846,
	"./dankort.png": 89570,
	"./diners.png": 20080,
	"./directdebit.png": 52133,
	"./discover.png": 72619,
	"./ebay.png": 96090,
	"./eway.png": 37165,
	"./jcb.png": 68865,
	"./maestro.png": 18928,
	"./mastercard.png": 54380,
	"./paypal.png": 90084,
	"./sage.png": 53954,
	"./shopify.png": 30705,
	"./skrill.png": 19506,
	"./solo.png": 45959,
	"./visa.png": 12863,
	"./visaelectron.png": 27777,
	"./westernunion.png": 68495,
	"./worldpay.png": 33887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37661;